import React from "react";
import AboutBackground from "../Assets/about-background.png";
import AboutBackgroundImage from "../Assets/about-background-image.png";
import { BsFillPlayCircleFill } from "react-icons/bs";

const About = () => {
	return (
		<div className="about-section-container">
			{/* <div className="about-background-image-container">
				<img src={AboutBackground} alt="" />
			</div> */}
			<div className="about-section-image-container">
				<img src={AboutBackgroundImage} alt="" />
			</div>
			<div className="about-section-text-container">
				{/* <p className="primary-subheading">About</p> */}
				<h1 className="primary-heading">
					Never Miss Out on Trending Topics
				</h1>
				<p className="primary-text">
					With tags on each entry, you would never miss out on any trending entries or discussions.
				</p>
				<p className="primary-text">
					Entries that have been shared publicly of course.
				</p>
				<div className="about-buttons-container">
					<button className="secondary-button">Learn More</button>
					{/* <button className="watch-video-button">
						<BsFillPlayCircleFill /> Watch Video
					</button> */}
				</div>
			</div>
		</div>
	);
};

export default About;
